import { Orbit } from './Orbit.tsx';
import { Add } from './pieces/index.ts';

type Props = Omit<React.ComponentProps<typeof Orbit>, 'children'>;

export function OrbitAdd(props: Props) {
  return (
    <Orbit {...props}>
      <Add />
    </Orbit>
  );
}
